module.exports = __webpack_public_path__ + "static/media/addon-light.80d64e49.svg";